<template>
  <a-modal
    centered
    :visible="visible"
    :title="title"
    :width="width"
    :zIndex="zIndex"
    :maskClosable="maskClosable"
    :closable="false"
    :footer="null"
    @cancel="handleCancel"
    :wrapClassName="`base-modal-wrap ${wrapClassName}`"
  >
    <div class="base-modal-content">
      <slot></slot>
    </div>

    <!-- 统一底部的按钮区 -->
    <div class="base-modal-footer" v-if="$slots.footer || showFooter">
      <slot name="footer">
        <button v-if="showCancel" type="button" class="btn btn-cancel" @click="handleCancel">
          {{ cancelText }}
        </button>
        <button v-if="showOk" type="button" class="btn btn-submit" @click="handleOk" :disabled="okLoading || disableOk">
          <span v-if="okLoading">Loading...</span>
          <span v-else>{{ okText }}</span>
        </button>
      </slot>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'BaseModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '' // 如果为空则没有标题栏文字，但高度可能还在
    },
    width: {
      type: [Number, String],
      default: 520
    },
    maskClosable: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: true
    },
    wrapClassName: {
      type: String,
      default: ''
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    showOk: {
      type: Boolean,
      default: true
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    okText: {
      type: String,
      default: 'Submit'
    },
    okLoading: {
      type: Boolean,
      default: false
    },
    zIndex: {
      type: Number,
      default: undefined
    },
    disableOk: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleCancel() {
      this.$emit('cancel');
    },
    handleOk() {
      this.$emit('ok');
    }
  }
}
</script>

<style>
/* 统一定义 BaseModal 的 UI 样式 */
.base-modal-wrap .ant-modal-header {
  text-align: center;
  border-bottom: 1px solid #f0f0f0;
  padding: 20px 24px;
  border-radius: 15px;
}

.base-modal-wrap .ant-modal-title {
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
}

.base-modal-wrap .ant-modal-body {
  padding: 30px 24px;
}

/* 统一底部按钮区域 */
.base-modal-wrap .base-modal-footer {
  display: flex;
  gap: 12px;
  margin-top: 24px;
  justify-content: center;
}

.base-modal-wrap .base-modal-footer .btn {
  min-width: 140px;
  height: 48px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.base-modal-wrap .btn-cancel {
  background: #e8ecf4;
  color: #1a1a1a;
}

.base-modal-wrap .btn-cancel:hover {
  background: #d8dce4;
}

.base-modal-wrap .btn-submit {
  background: var(--brandColor);
  color: #fff;
}

.base-modal-wrap .btn-submit:hover {
  background: var(--brandColor);
  filter: brightness(0.95);
}

.base-modal-wrap .btn-submit:disabled {
  background: #a0b0d0;
  filter: none;
  cursor: not-allowed;
}

/* 内容布局使用 */
.base-modal-content {
  text-align: center;
}
.base-modal-content p {
  color: #666;
  font-size: 15px;
  line-height: 1.6;
}
</style>



// WEBPACK FOOTER //
// src/components/BaseModal.vue